import { createContext, useContext, useEffect, useState } from "react";

const ProductsContext = createContext();

export function ProductsProvider({ children }) {
  const [products, setProducts] = useState([]);

   useEffect(() => {
      const fetchProducts = async () => {
        try {
          const res = await fetch("https://beadastra-a7epexf5c5b7dng0.canadacentral-01.azurewebsites.net/products");
          const data = await res.json();
          if (Array.isArray(data)) {
            setProducts(data);
          }
        } catch (error) {
          console.error("Error cargando productos:", error);
        }
      };    
      fetchProducts();
    }, []);

  return (
    <ProductsContext.Provider value={{ products }}>
      {children}
    </ProductsContext.Provider>
  );
}

export const useProducts = () => useContext(ProductsContext);
